
import { createTheme } from '@mui/material/styles';
import { COLOR_MAP } from '../constants/ColorNames';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

const theme = createTheme({
    palette: {
        primary: {
            main: '#009BDF',
        },
        secondary: {
            main: '#14568D',
        },
        error: {
            main: '#FF0000',
        },
    },
    typography: {
        fontFamily: 'Noto Sans',
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    width: '100%',
                    fontSize: '1.4rem',
                    fontWeight: 400,
                    lineHeight: '2rem',
                    '.MuiInputBase-multiline': {
                        padding: '1.2rem !important'
                    },
                    '.MuiInputBase-inputMultiline': {
                        fontSize: '1.4rem',
                        fontWeight: 400,
                        lineHeight: '2rem',
                        overflow: 'hidden',
                        padding: '0!important',

                    }
                },
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    width: '100%',
                    fontSize: '1.4rem',
                    fontWeight: 400,
                    lineHeight: '2rem',
                    input: {
                        padding: '1.2rem',
                        height: 'auto',
                    },
                    '&:hover:not(.Mui-disabled, .Mui-error)::before ': {
                        borderBottom: '0 !important'
                    },

                    '& fieldset': {
                        borderColor: COLOR_MAP.BORDER_GREY,
                        borderWidth: '0.1rem !important',
                    },

                    '&:hover:not(.Mui-error) fieldset': {
                        borderColor: COLOR_MAP.BORDER_GREY + '!important'
                    },
                    "&.Mui-focused:not(.Mui-error) fieldset": {
                        borderColor: COLOR_MAP.BORDER_GREY + '!important'
                    },
                    '& > [role="button"]': {
                        padding: '0',
                        ':focus': {
                            backgroundColor: 'transparent'
                        }
                    },
                    ".MuiSelect-select": {
                      minHeight: 'auto !important',
                    },

                },

            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    padding: '1.2rem !important'
                    ,
                    "&:focus": {
                        backgroundColor: 'transparent !important'
                    },
                    // "&.MuiSelect-select": {
                    //   minHeight: 'auto'
                    // }
                },
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '1.2rem',
                    fontWeight: 400,
                    // "&:hover": {
                    //     backgroundColor: COLOR_MAP.LIGHT_PURPLE,
                    //     borderWidth: '0.1rem !important'
                    // },


                    // "&.Mui-selected:hover": {
                    //     backgroundColor: COLOR_MAP.LIGHT_PURPLE
                    // },
                    // '&.Mui-focusVisible': {
                    //     backgroundColor: COLOR_MAP.LIGHT_PURPLE
                    // },
                    "&$selected": {
                        backgroundColor: COLOR_MAP.LIGHT_PURPLE,
                        "&:hover": {
                            backgroundColor: COLOR_MAP.LIGHT_PURPLE
                        }
                    },
                    "&:hover": {
                        backgroundColor: COLOR_MAP.LIGHT_PURPLE
                    },
                    "&.Mui-focused": {
                        backgroundColor: COLOR_MAP.LIGHT_PURPLE
                    },
                    "&.Mui-focusVisible": {
                        backgroundColor: COLOR_MAP.LIGHT_PURPLE
                    },
                    "&.Mui-selected": {
                        backgroundColor: COLOR_MAP.LIGHT_PURPLE,
                        "&:hover": {
                            backgroundColor: COLOR_MAP.LIGHT_PURPLE
                        },
                        "&.Mui-focused": {
                            backgroundColor: COLOR_MAP.LIGHT_PURPLE
                        },
                        "&.Mui-focusVisible": {
                            backgroundColor: COLOR_MAP.LIGHT_PURPLE
                        },
                    },

                },
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "& > svg": {
                        color: 'rebeccapurple',
                        width: '20px',
                        height: '20px'
                    }
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    maxHeight: '16rem',
                    '& > li': {
                        padding: 0
                    }
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    "& > span": {
                        fontSize: '1.2rem',
                        fontWeight: '400',
                        color: '#1D1934',
                        lineHeight: '20px',

                    }


                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    '::-webkit-scrollbar': {
                        width: '0.4rem'
                    },
                    '::-webkit-scrollbar-thumb': {
                        backgroundColor: COLOR_MAP.GREY_1,
                        borderRadius: '0.8rem',
                        height: '9.6rem'
                    },
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontWeight: 400,
                    fontSize: '1.2rem',
                    lineHeight: '1.6rem',
                    padding: '0.6rem, 0.8rem, 0.6rem, 1.2rem',
                    backgroundColor: COLOR_MAP.PILL_Bk,
                    border: `0.1rem solid ${COLOR_MAP.PILL_BORDER}`,
                    color: COLOR_MAP.GREY_2,
                    width: '7rem',
                    height: '2.8rem',
                    '& > span': {
                        paddingLeft: '0.7rem',
                        paddingRight: 0,
                    },
                    '& > svg': {
                        color: `${COLOR_MAP.LAVENDER_GREY}!important`
                    }
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '.MuiAutocomplete-input': {
                        padding: '1.2rem !important'
                    },
                    '.MuiOutlinedInput-root': {
                        padding: '0 !important'

                    },


                }
            }
        },
        MuiPopper: {
            styleOverrides: {
                root: {
                    '.MuiAutocomplete-listbox': {
                        fontSize: '1.4rem',
                        fontWeight: '400',
                        maxHeight: '16rem',
                        '::-webkit-scrollbar': {
                            width: '0.4rem'
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: COLOR_MAP.GREY_1,
                            borderRadius: '0.8rem',
                            height: '9.6rem'
                        },
                        '& .MuiAutocomplete-option[aria-selected="true"]': {
                            backgroundColor: COLOR_MAP.LIGHT_PURPLE,
                            "&.Mui-focused": {
                                backgroundColor: COLOR_MAP.LIGHT_PURPLE,
                            }
                        }
                        ,
                        "& .MuiAutocomplete-option.Mui-focused": {
                            backgroundColor: COLOR_MAP.LIGHT_PURPLE,
                        },
                    }
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    fontSize: '1.2rem',
                    padding: 0
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: '1.4rem',
                    padding: '1.2rem 1.6rem',
                    fontWeight: '600',
                    lineHeight: '2rem',
                },
                text: {
                    padding: '1.2rem',
                    color: COLOR_MAP.DARK_PURPLE,
                    "&:hover": {
                        backgroundColor: COLOR_MAP.WHITE
                    }
                },
                outlined: {
                    color: COLOR_MAP.DARK_PURPLE,
                    borderColor: COLOR_MAP.DARK_PURPLE,
                    "&:hover": {
                        borderColor: COLOR_MAP.DARK_PURPLE,
                        backgroundColor: COLOR_MAP.WHITE
                    }
                },
                contained: {
                    backgroundColor: COLOR_MAP.DARK_PURPLE,
                    color: COLOR_MAP.WHITE,
                    boxShadow: 'none',
                    "&:hover": {
                        backgroundColor: COLOR_MAP.DARK_PURPLE,
                        boxShadow: 'none'
                    }
                },

            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '1.2rem',
                    marginLeft: 0,
                    color: 'red'
                },
            }
        },

        MuiTooltip: {
            styleOverrides: {
                'arrow': {
                    '&::before': {
                        borderRadius: '2rem',
                        backgroundColor: COLOR_MAP.LIGHT_GREY,
                        transform: 'skew(-62deg, 86deg)'
                    }
                },
                'tooltipArrow': {
                    backgroundColor: 'transparent',
                    fontSize: '1.8rem',
                    padding: 0,
                    maxWidth: '50rem'
                }
            }
        },

        MuiPagination: {
          styleOverrides: {
            root: {
              '.MuiPagination-ul': {
                gap: '0.4rem',

                '.MuiButtonBase-root': {
                padding: 0,
                margin: 0,
                minWidth: '2rem',
                height: '2rem',
                fontSize: '1.4rem',
                fontWeight: '400',
                lineHeight: '1.4rem'
                }
              },
              '& .Mui-selected': {
                color: `${COLOR_MAP.PILL_Bk}`,
                border: `1px solid ${COLOR_MAP.PRIMARY}`,
              },
            }
          }
        },

        MuiPaginationItem: {
          styleOverrides: {
            root: {
              '.MuiPaginationItem-icon': {
                height: '1.6rem',
                width: '1.6rem',
                color: `${COLOR_MAP.DARK_PURPLE}`,
                border: `1px solid ${COLOR_MAP.LAVENDER_PRIMARY}`,
                backgroundColor: `${COLOR_MAP.WHITE}`,
                borderRadius: '0.4rem',
              },
            },
          },
    },
    MuiAlert: {
        styleOverrides: {
            filledInfo: {
                backgroundColor: 'black',
                color: 'white',
            },
            filledSuccess: {
                backgroundColor: '#2BA682',
                color: 'white',
            },
        },
        defaultProps: {
            iconMapping: {
                success: <CheckCircleOutlinedIcon/>,
            },
        },
    }
  }
});

export default theme